export const orchestratorConstants = {
  UPDATE_INVENTORY_PRESETS: "df-update-inventory-preset-orchestrator",
  IMPORT_INVENTORY: "df-inventory-import-orchestrator",
};
